/**
 * This context is used to refetch issues count and tasks while auto sync with jira model is closed
 */
import React, { Dispatch, SetStateAction, useCallback, useState } from 'react';

import { createContext } from '@lyearn/core/utils/context';

export type RefetchType = { refetchTaskCount?: () => void; refetchTasks?: () => void };

export type TaskRefetchContextType = {
  refetch: RefetchType;
  setRefetch: Dispatch<SetStateAction<RefetchType>>;
};

const [TaskRefetchContext, useTaskRefetchContext] =
  createContext<TaskRefetchContextType>('TaskRefetchContextType');

const useTaskRefetch = () => {
  const { refetch, setRefetch } = useTaskRefetchContext();

  const _refetch = useCallback(() => {
    refetch?.refetchTaskCount?.();
    refetch?.refetchTasks?.();
  }, [refetch]);

  const setTaskCountRefetch = useCallback(
    (refetchTaskCount?: () => void) => {
      setRefetch((prevState) => ({ ...prevState, refetchTaskCount }));
    },
    [setRefetch],
  );

  const setTasksRefetch = useCallback(
    (refetchTasks?: () => void) => {
      setRefetch((prevState) => ({ ...prevState, refetchTasks }));
    },
    [setRefetch],
  );

  return { refetch: _refetch, setTaskCountRefetch, setTasksRefetch };
};

const TaskRefetchContextProvider: React.FC<React.PropsWithChildren> = (props) => {
  const { children } = props;
  const [refetch, setRefetch] = useState<RefetchType>({
    refetchTasks: undefined,
    refetchTaskCount: undefined,
  });

  return (
    <TaskRefetchContext refetch={refetch} setRefetch={setRefetch}>
      {children}
    </TaskRefetchContext>
  );
};

export { TaskRefetchContextProvider, useTaskRefetch };
